import { FormProvider } from "../../../components-common/forms/provider";
import { Page } from "./Page";
import { Toolbar } from "@components-common/toolbar";
import { FC, useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { getProps } from "@components-system";
import { FormBase } from "@components-common/forms";
import { FormComponent } from "../../../components-common/containers";
import { isObj } from "ramda-adjunct";
import { useParams } from "react-router-dom";
import { application } from "../../../_runtime/bootstrap";
import { Loader } from "taltech-styleguide";

const MainContent: FC<any> = ({ toolbar, form }) => {
  const formik = useFormikContext();
  if (toolbar.left && !isObj(toolbar.left[0])) {
    const newLeft = {
      kind: toolbar.left[0],
      onAction: () => {
        formik.submitForm();
        if(formik.isValid) formik.setSubmitting(true);
      },
    };

    toolbar.left = [newLeft, ...toolbar.left.slice(1)];
  }

  return (
    <>
      <Toolbar {...toolbar} />
      <FormComponent {...form} />
    </>
  );
};

export const PageFormToolbar = (props: any) => {
  const { toolbar, form } = props;
  const { idPropSource = 'id' } = form;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [editElement, setEditElement] = useState<any>({});
  const id = useParams()[idPropSource];
  useEffect(() => {
    if (props.form.id.includes("edit") && id !== undefined) {
      setIsLoading(true);
      try {
        application
          .getHttpClient()
          .get(`${form.editSource}${id}`)
          .then((res: any) => {
            setIsLoading(false);
            setEditElement(res.body);
          });
      } catch (e) {
        console.log(e);
      }
    } else setIsLoading(false);
  }, []);
  const normProps = getProps(form);
  let finalProps = { ...normProps };
  if (props.form.id.includes("edit")) {
    finalProps = {
      id: props.form.id,
      ...normProps,
      element: editElement ?? {},
    };
  } else {
    finalProps = {
      id: props.form.id,
      ...normProps,
      element: normProps.empty ?? {},
    };
  }

  return (
    <Page {...props}>
      {isLoading ? (
        <Loader overlay />
      ) : (
        <FormProvider>
          <FormBase {...finalProps}>
            <MainContent form={form} toolbar={toolbar} />
          </FormBase>
        </FormProvider>
      )}
    </Page>
  );
};
